export default "__VITE_ASSET__DLDPI53C__"